import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const DOC_FIELDS = [
  CPropertyFormKeys.file_title_property,
  CPropertyFormKeys.file_capture_details_property,
  CPropertyFormKeys.file_owner_id_property,
  CPropertyFormKeys.file_application_form_property,
  CPropertyFormKeys.file_power_ownership_property,
  CPropertyFormKeys.file_commercial_registry_property,
  CPropertyFormKeys.file_property_contract_property
];

/**
 * Revalidates document fields when business type or project flag change.
 * Prevents stale required errors when requirement toggles.
 */
export const useRevalidateDocumentDeps = () => {
  const {
    trigger,
    formState: { isDirty }
  } = useFormContext();
  const [businessTypes, isProject] = useWatch({
    name: [CPropertyFormKeys.business_types_property, CPropertyFormKeys.is_project]
  });

  useEffect(() => {
    if (!isDirty) return;
    // Debounced by RHF's internal queue; explicit trigger ensures clean state
    trigger(DOC_FIELDS);
  }, [JSON.stringify(businessTypes), isProject, isDirty]);
};

export default useRevalidateDocumentDeps;
